import { injectable } from "inversify";
import { LocalizedCountries, LocalizedLanguages } from "../domain";

@injectable()
export abstract class I18nLocalizedResourceService {
    abstract getCountries(): Promise<LocalizedCountries>;
    
    abstract getLanguages(): Promise<LocalizedLanguages>;
}
